import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import {
  getMenuSectionTitlesTypography,
  getItemDescriptionsAndPricesTypography
} from 'styles/helpers/getThemeStyles';
import { calculateRgbaWithAlpha } from 'helpers/colorFormatter';
import { OPACITY_73 } from 'constants/opacity';
import {
  SEARCH_LENGTH,
  COULD_NOT_FIND_TEXT,
  DESCRIPTION_TEXT,
  NOT_ENOUGH_CHARACTERS
} from 'bento-ordering/menus/constants/search';

const Container = styled(Box)(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(2)
    }
  };
});

const StyledHeading = styled(Typography)(({ theme }) => {
  const fontStyles = {
    ...getMenuSectionTitlesTypography(theme)
  };

  return {
    color: theme.palette.sectionNav.link.main,
    ...fontStyles
  };
});

const StyledDescription = styled(Typography)(({ theme }) => {
  return {
    color: calculateRgbaWithAlpha(
      theme.palette.sectionNav.link.main,
      OPACITY_73
    ),
    ...getItemDescriptionsAndPricesTypography(theme),
    fontSize: '12px',
    letterSpacing: '0px'
  };
});

const NoSearchResults = ({ searchTerm }) => {
  const searchTermLongEnough = searchTerm.length >= SEARCH_LENGTH;
  return (
    <Container>
      <StyledHeading>
        {searchTermLongEnough
          ? `${COULD_NOT_FIND_TEXT} “${searchTerm}”.`
          : NOT_ENOUGH_CHARACTERS}
      </StyledHeading>
      {searchTermLongEnough && (
        <StyledDescription>{DESCRIPTION_TEXT}</StyledDescription>
      )}
    </Container>
  );
};

NoSearchResults.propTypes = {
  searchTerm: PropTypes.string.isRequired
};

export default NoSearchResults;
